import { render, staticRenderFns } from "./product_detail_management.vue?vue&type=template&id=325a7858&scoped=true&"
import script from "./product_detail_management.vue?vue&type=script&lang=js&"
export * from "./product_detail_management.vue?vue&type=script&lang=js&"
import style0 from "./product_detail_management.vue?vue&type=style&index=0&id=325a7858&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325a7858",
  null
  
)

export default component.exports